export function cleanNumericInput(value) {
  if (value === null || value === undefined) return '';

  const compact = String(value)
    .replace(/\s/g, '')
    .replace(/'/g, '')
    .replace(/,/g, '.')
    .replace(/[^\d.-]/g, '');

  if (compact === '-' || compact === '.' || compact === '-.') {
    return compact;
  }

  const isNegative = compact.startsWith('-');
  const unsigned = compact.replace(/-/g, '');
  const hasDecimal = unsigned.includes('.');
  const [intPart = '', ...decimalParts] = unsigned.split('.');
  const decimalPart = decimalParts.join('');

  return `${isNegative ? '-' : ''}${intPart}${hasDecimal ? `.${decimalPart}` : ''}`;
}

export function formatNumericInput(value) {
  if (value === null || value === undefined || value === '') return '';

  const cleaned = cleanNumericInput(value);
  if (cleaned === '' || cleaned === '-' || cleaned === '.' || cleaned === '-.') {
    return cleaned;
  }

  const isNegative = cleaned.startsWith('-');
  const unsigned = isNegative ? cleaned.slice(1) : cleaned;
  const [intPart = '', decimalPart] = unsigned.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  return `${isNegative ? '-' : ''}${formattedInt}${decimalPart !== undefined ? `.${decimalPart}` : ''}`;
}

export function parseNumericInput(value) {
  const cleaned = cleanNumericInput(value);

  if (!/^-?\d+(?:\.\d+)?$/.test(cleaned)) {
    return NaN;
  }

  return Number(cleaned);
}
